import type { BreadcrumbsProps } from '@/components/Breadcrumbs/types';
import type { Collection } from '@/types/collection';
import { MUSIC_BREADCRUMB_ROOT } from './get-music-breadcrumbs';
import { SFX_BREADCRUMB_ROOT } from './get-sfx-breadcrumbs';

export const getCollectionBreadcrumbs = ({
  collection,
  assetType,
}: {
  collection: Collection;
  assetType: 'music' | 'sfx';
}): BreadcrumbsProps => {
  const root =
    assetType === 'sfx' ? SFX_BREADCRUMB_ROOT : MUSIC_BREADCRUMB_ROOT;
  const basePath =
    assetType === 'sfx' ? '/sfx/collection' : '/music/collection';

  return {
    previous: [
      root,
      {
        id: 'collections',
        label: 'Collections',
        slug: 'collection',
        relative_url: basePath,
      },
    ],
    current: {
      id: collection.id.toString(),
      label: collection.name,
      slug: collection.slug,
      relative_url: `${basePath}/${collection.slug}`,
    },
    assetType,
  };
};
